import Vue from "vue";

// let path = "http://192.168.1.170:80/"; //测试服
// Vue.prototype.pathURL = "http://192.168.1.170:80/"; //测试服
// Vue.prototype.link = "http://192.168.1.184"; //测试

// let path = 'https://uatnewapi.hezongyy.com/' //预生产
// Vue.prototype.pathURL = "https://uatnewapi.hezongyy.com/"; //预生产
// Vue.prototype.link = "https://uatweb.hezongyy.com"; //预生产

let path = 'https://newapi.hezongyy.com/'; //正式服
Vue.prototype.pathURL = "https://newapi.hezongyy.com/"; //正式服
Vue.prototype.onekeyPathURL = "https://onekey.hezongyy.com/";
Vue.prototype.link = "https://www.hezongyy.com"; //正式

const url = {
  // 下 单 抽 奖 次 数
  submitTimes: path + "person/LuckyDraw/getLuckyDrawTimes/1",
  // 下 单 抽 奖 中 奖 名 单
  luckUsers: path + "person/LuckyDraw/getLuckyWinnersList/1",
  // 下 单 抽 奖
  startLuck: path + "person/LuckyDraw/luckyDraw/1",
  // 下 单 抽 奖 抽 中 奖  品
  getPrize: path + "person/LuckyDraw/getWinningPrizesList/1",
  // 
  getAmount: path + "person/HighQualityPoints/getTotalAmount",
  // 
  getRebate: path + "person/HighQualityPoints/rebateAmount",
  // 用户积分
  pointsInfo: path + "person/PointsHomePage/info",
  // 点击签到
  pointsSign: path + "person/PointSignIn/SignIn",
  // 查询购物车总数量
  shopCarTotal: path + "settlement/userShoppingCart/getShoppingCartGoodsCount",
  // 签到
  getSign: path + "person/PointSignIn/activitySignIn",
  // 签到信息
  getSignIn: path + "person/PointSignIn/activitySignInItem",
  // 厂家特供
  getSpecial: path + "goods/ad/v2/byPage/list",
  // 商家banner
  getBanner: path + "goods/ad/v2/byPage",
  // 买赠换购
  getExchange: path + "goods/119/giftRule",
  //
  time119: path + "goods/119/time",
  // 加入购物车  原接口/goodsCart/addGoodsCart
  addShopCar: path + "settlement/userShoppingCart/addGoodsCart",
  //  领取优惠券ReceiveCoupon
  getTickets: path + "person/CouponCollectionCenter/receive",
  // 领劵状态
  getDatas: path + "person/CouponCollectionCenter/getReceiveStatus",
  //  一键入库
  postOneKey: path + "plugin/version/download"
}
export default url



// WEBPACK FOOTER //
// ./src/axios/apiUrl.js